import React from 'react';
import { ConfigurationState } from 'ui/editor/dataStream/TileEditor/state/TileEditorState';
import { defaultOnCreate } from '../autocomplete/Autocomplete';
import { getFormFieldComponent } from '../field/getFormFieldComponent';
import { isAutocomplete } from './autocompleteOptions';
import { ResolvedUIConfigWithTest } from './DisplayJsonUi';

interface DisplayJsonUiFieldProps {
    field: ResolvedUIConfigWithTest;
    index: number;
    disabled: boolean;
    data: Record<string, string>;
    autoFocus: boolean;
    menuPortalTarget?: HTMLElement | null;
    className?: string;
    labelClassName?: string;
    fieldClassName?: string;
    configurationState?: ConfigurationState[string];
    handleConfigurationStateChange?: (data: Record<string, string | number>) => void;
}

export const DisplayJsonUiField: React.FC<DisplayJsonUiFieldProps> = ({ 
    field, 
    index,
    disabled,
    data,
    autoFocus,
    menuPortalTarget,
    className,
    labelClassName,
    fieldClassName,
    configurationState,
    handleConfigurationStateChange
}) => {
    // After retrieving an encrypted password value, we may find that our ciphertext
    // exceeds the original maxLength validation rules! So we'll remove that
    // validation rule if it exists.
    if (field.type === 'password' && data[field.name]?.startsWith('squp_encrypted')) {
        if (field.validation?.maxLength) {
            delete field.validation.maxLength;
        }
    }

    const FormField = getFormFieldComponent(field.type);

    return (
        // Our pattern validation has the pattern validation as a string,
        // but the react-hook-form types want it to be a RegExp
        // @ts-expect-error
        <FormField
            autoFocus={index === 0 && autoFocus}
            key={field.name}
            {...field}
            disabled={disabled || ('disabled' in field && field.disabled === true)}
            {...(isAutocomplete(field) && {
                onCreate: field.allowCustomValues !== false ? defaultOnCreate : undefined,
                //AutoComplete uses isDisabled instead of disabled
                isDisabled: disabled || field.disabled === true
            })}
            menuPortalTarget={menuPortalTarget}
            className={className}
            labelClassName={labelClassName}
            fieldClassName={fieldClassName}
            configurationState={configurationState}
            handleConfigurationStateChange={handleConfigurationStateChange}
        />
    );
};
